import script from "./PackagesCards.vue?vue&type=script&setup=true&lang=js"
export * from "./PackagesCards.vue?vue&type=script&setup=true&lang=js"

import "./PackagesCards.vue?vue&type=style&index=0&id=7e72886a&lang=scss"

const __exports__ = script;

export default __exports__